module.exports = __webpack_public_path__ + "static/img/01Hai.e856ecd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/01Hai.gif
// module id = Mr+h
// module chunks = 0